import { faCode } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDisclosure } from '@mantine/hooks';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, CardV2 as Card } from '@feathr/components';

import EmbedScriptInstructionsModal from './EmbedScriptInstructionsModal';

import * as styles from './EmbedScriptCard.css';

function EmbedScriptCard(): JSX.Element {
  const { t } = useTranslation();
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);

  return (
    <div>
      <Card width={'full'}>
        <Card.Header
          description={t('Add this embed script to your website to enable donation forms')}
          prefix={
            <div className={styles.iconContainer}>
              <FontAwesomeIcon className={styles.icon} icon={faCode} />
            </div>
          }
          title={t('Website Embed Setup')}
        >
          <Button onClick={openModal}>{t('Setup Embed')}</Button>
        </Card.Header>
        <EmbedScriptInstructionsModal onClose={closeModal} opened={opened} />
      </Card>
    </div>
  );
}

export default EmbedScriptCard;
